import { msg } from '@gonfalon/messages/msg';

import { mapToolNameToUserFriendlyToolName } from '../agentInsightsUtils';

const AGENTCORE_OBSERVABILITY_PREFIX = 'observability_';

export const toolProgressLabel = (toolName: string) => {
  const name = toolName.startsWith(AGENTCORE_OBSERVABILITY_PREFIX)
    ? `mcp__observability__${toolName.slice(AGENTCORE_OBSERVABILITY_PREFIX.length)}`
    : toolName;
  if (name === 'mcp__observability__get_keys') {
    return msg('vega.askVegaProgress.checkingAttributes');
  }
  if (name === 'mcp__observability__get_values') {
    return msg('vega.askVegaProgress.samplingValues');
  }
  return mapToolNameToUserFriendlyToolName(name);
};
